import React from "react";
import { useTheme } from "@material-ui/core/styles";

const Logo = ({ style, forceLight }) => {
  const theme = useTheme();
  // forceLight = always use white text (e.g. on dark hero panels)
  const textColor = forceLight ? "#FFFFFF" : (theme.palette.type === "light" ? "#1E293B" : "#FFFFFF");
  // On dark/gradient backgrounds, JO accent should be lighter too
  const accentColor = forceLight ? "#A5B4FC" : "#4F46E5";

  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 320 100" 
      style={{ width: "auto", height: "52px", ...style }}
    >
      <defs>
        <linearGradient id="mainGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#4F46E5"/>
          <stop offset="100%" stopColor="#8B5CF6"/>
        </linearGradient>

        <filter id="softShadow" x="-10%" y="-10%" width="120%" height="120%">
          <feDropShadow dx="0" dy="3" stdDeviation="2.5" floodColor="#4F46E5" floodOpacity="0.15"/>
        </filter>
      </defs>

      <g transform="translate(10, 7.5)">
        <path d="M42 10 H55 C63.28 10 70 16.72 70 25 V38 C70 46.28 63.28 53 55 53 H48 V62 L37 53 H28 C19.72 53 13 46.28 13 38 V25 C13 16.72 19.72 10 28 10 Z" fill="#0EA5E9" opacity="0.9"/>
        <path d="M25 22 H48 C56.28 22 63 28.72 63 37 V50 C63 58.28 56.28 65 48 65 H42 V75 L30 65 H25 C16.72 65 10 58.28 10 50 V37 C10 28.72 16.72 22 25 22 Z" fill="url(#mainGradient)" filter="url(#softShadow)"/>
        <circle cx="23" cy="43.5" r="3.5" fill="#FFFFFF"/>
        <circle cx="36.5" cy="43.5" r="3.5" fill="#FFFFFF"/>
        <circle cx="50" cy="43.5" r="3.5" fill="#FFFFFF"/>
      </g>

      <text 
        x="96" 
        y="64" 
        fontFamily="-apple-system, BlinkMacSystemFont, 'Inter', 'Segoe UI', Roboto, sans-serif" 
        fontSize="44" 
        fontWeight="800" 
        letterSpacing="-1"
      >
        <tspan fill={textColor}>Messa</tspan><tspan fill={accentColor} dx="2">JO</tspan>
      </text>
    </svg>
  );
};

export default Logo;
